import $axios from 'axios'
import {
    changeStatusUri,
    candidateOrdersViewUri,
    handleRecommndUri,
    handleRecommendListUri,
    orderTalkUri,
    orderDetailUri,
    questionListUri,
    jReportInfoUri,
    replaceOfferUri,
    candidateListUri,
    getReasonInfoUri
} from '../config/uri'
//更新候选人订单进度
export function changeStatus(params) {
    return $axios.post(changeStatusUri, params)
}
//查看并筛选
export function candidateOrdersView(params) {
    return $axios.post(candidateOrdersViewUri, params)
}
//查看当前职位详情
export function handleRecommnd(params) {
    return $axios.post(handleRecommndUri, params)
}
//微信处理简历列表
export function handleRecommendList(params) {
    return $axios.post(handleRecommendListUri, params)
}
// 候选人沟通通过记录
export function getOrderTalk(params) {
    return $axios.post(orderTalkUri, params)
}
// 候选人订单详情
export function getOrderDetail(params) {
    return $axios.post(orderDetailUri, params)
}
// 候选人必问问题
export function getQuestionList(params) {
    return $axios.post(questionListUri, params)
}
// 候选人推荐报告
export function getJReportInfo(params) {
    return $axios.post(jReportInfoUri, params)
}
//催一下接口
export function replaceOfferDetail(params) {
    return $axios.post(replaceOfferUri, params)
}
//候选人列表
export function getCandidateList(params) {
    return $axios.post(candidateListUri, params)
}
// 获取候选人订单中止原因
export function getReasonInfo(params) {
    return $axios.post(getReasonInfoUri, params)
}
